module.exports = __webpack_public_path__ + "static/media/email.e6c0cd20.png";